import React, { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";

const ViewVisaLinkButton = ({ userId, className = "next-button" }) => {
  const [loading, setLoading] = useState(false);
  const [visaLink, setVisaLink] = useState("");
  const [visaRecord, setVisaRecord] = useState(null);

  const normalizeData = (data) => {
    if (!data) return null;
    if (data.visa) return data.visa;
    if (data.data?.visa) return data.data.visa;
    if (Array.isArray(data.data) && data.data.length > 0) return data.data[0];
    if (data.data && typeof data.data === "object") return data.data;
    if (Array.isArray(data) && data.length > 0) return data[0];
    if (typeof data === "object") return data;
    return null;
  };

  const fetchVisaLink = async () => {
    if (!userId) return;

    try {
      setLoading(true);
      const res = await axios.get(`https://eventscons.com/eventbackendnew/api/visa?user_id=${userId}`);
      const mapped = normalizeData(res.data);

      if (mapped) {
        setVisaRecord(mapped);
        setVisaLink(mapped.last_url || mapped.url || mapped.visa_url || "");
      } else {
        setVisaRecord(null);
        setVisaLink("");
      }
    } catch (error) {
      setVisaRecord(null);
      setVisaLink("");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVisaLink();
  }, [userId]);

  if (!userId) return null;

  if (loading) {
    return (
      <button type="button" className={className} disabled>
        Loading...
      </button>
    );
  }

  if (!visaLink) {
    return (
      <button type="button" className={className} disabled>
        Visa Link Not Found
      </button>
    );
  }

  return (
    <button
      type="button"
      className={className}
      onClick={() => window.open(visaLink, "_blank", "noopener,noreferrer")}
    >
      View Visa Link
    </button>
  );
};

export default ViewVisaLinkButton;